import actions from './actions';

const {
  setIsShowing,
  setScene,
  setPodcastName,
  setPodcastDescription,
  setPodcastItunesCategory,
} = actions;

const goBackToFirstScene = () => dispatch => {
  dispatch(setScene('form'));
};

const close = () => dispatch => {
  dispatch(setIsShowing(false));
};

const open = () => dispatch => {
  dispatch(setIsShowing(true));
};

const closeAndReset = () => dispatch => {
  dispatch(close(false));
  dispatch(goBackToFirstScene());
};

export default {
  open,
  closeAndReset,
  setIsShowing,
  setScene,
  setPodcastName,
  setPodcastDescription,
  setPodcastItunesCategory,
};
